import * as React from 'react';
import { AngleDownIcon, AngleRightIcon } from '@patternfly/react-icons';

interface JsonViewerProps {
  data: any;
  name?: string;
  isLast?: boolean;
  initiallyExpanded?: boolean;
}

export const JsonViewer: React.FC<JsonViewerProps> = ({ data, name, isLast = true, initiallyExpanded = true }) => {
  const [isExpanded, setIsExpanded] = React.useState(initiallyExpanded);

  const isComplex = typeof data === 'object' && data !== null;
  const isArray = Array.isArray(data);
  const isEmpty = isComplex && Object.keys(data).length === 0;

  // Render Primitives (Strings, Numbers, Booleans)
  if (!isComplex) {
    const valueColor = typeof data === 'string' ? 'var(--pf-v6-global--success-color--100)' :
                       typeof data === 'number' ? 'var(--pf-v6-global--primary-color--100)' :
                       typeof data === 'boolean' ? 'var(--pf-v6-global--warning-color--100)' : 
                       'var(--pf-v6-global--Color--dark-200)';
    return (
      <div style={{ marginLeft: '24px', fontFamily: 'monospace', fontSize: '14px', lineHeight: '1.6' }}>
        {name && <span style={{ color: 'var(--pf-v6-global--Color--100)', fontWeight: 'bold' }}>&quot;{name}&quot;: </span>}
        <span style={{ color: valueColor }}>
          {typeof data === 'string' ? `"${data}"` : String(data)}
        </span>
        {!isLast && <span style={{ color: 'var(--pf-v6-global--Color--100)' }}>,</span>}
      </div>
    );
  }

  // Render Complex Objects / Arrays
  const keys = Object.keys(data);
  const openBrace = isArray ? '[' : '{';
  const closeBrace = isArray ? ']' : '}';

  return (
    <div style={{ marginLeft: name ? '24px' : '0px', fontFamily: 'monospace', fontSize: '14px', lineHeight: '1.6' }}>
      <div
        onClick={() => !isEmpty && setIsExpanded(!isExpanded)}
        style={{ cursor: isEmpty ? 'default' : 'pointer', display: 'flex', alignItems: 'flex-start', userSelect: 'none' }}
      >
        {/* Toggle Icon - FIX: Removed the size prop, it will naturally scale to 1em */}
        {!isEmpty && (
          <span style={{ marginRight: '6px', width: '12px', display: 'inline-block', marginTop: '2px', color: 'var(--pf-v6-global--icon--Color--light)' }}>
            {isExpanded ? <AngleDownIcon /> : <AngleRightIcon />}
          </span>
        )}
        {isEmpty && <span style={{ marginRight: '6px', width: '12px', display: 'inline-block' }}></span>}

        <span>
          {name && <span style={{ color: 'var(--pf-v6-global--Color--100)', fontWeight: 'bold' }}>&quot;{name}&quot;: </span>}
          <span style={{ color: 'var(--pf-v6-global--Color--dark-200)' }}>{openBrace}</span>
          {!isExpanded && !isEmpty && (
            <span style={{ color: 'var(--pf-v6-global--Color--dark-200)' }}> ... {closeBrace}{!isLast && ','}</span>
          )}
          {isEmpty && (
            <span style={{ color: 'var(--pf-v6-global--Color--dark-200)' }}>{closeBrace}{!isLast && ','}</span>
          )}
        </span>
      </div>

      {isExpanded && !isEmpty && (
        <div>
          {keys.map((key, index) => (
            <JsonViewer
              key={key}
              name={isArray ? undefined : key}
              data={(data as any)[key]}
              isLast={index === keys.length - 1}
              initiallyExpanded={initiallyExpanded}
            />
          ))}
          <div style={{ marginLeft: '24px', color: 'var(--pf-v6-global--Color--dark-200)' }}>
            {closeBrace}{!isLast && ','}
          </div>
        </div>
      )}
    </div>
  );
};